import { useState } from "react";
import { codepass } from "../services/codepass";

export function NewPass() {
  const [email, setEmail] = useState([]);
  const [code, setCode] = useState([]);
  const [password, setPassword] = useState([]);

  const [errorMessage, setErrorMessage] = useState("");

  const getCurrentYear = () => {
    return new Date().getFullYear();
  };

  const handleNewpass = async (e) => {
    e.preventDefault();
    console.log(email, code, password);
    try {
      await codepass(email, code, password).then(
        (data) => {
          console.log(data);
          if (typeof data.message !== "undefined") {
            const regex = /(<([^>]+)>)/gi;
            const cleanErrorMessage = data.message.replace(regex, "");
            setErrorMessage(cleanErrorMessage);
          }
          if (data?.data?.status === 200) {
            // Si la respuesta es 200, esperar 5 segundos y redirigir a la URL de inicio
            setTimeout(() => {
              window.location.replace("../");
            }, 3000);
          }
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div id='content' className='login-page'>
       <form onSubmit={handleNewpass}>
        <div className='login-full'>
        <div className='login-bg'></div>
          <div className='login-content'>
            <div className='login-form'>
              <h3>Establecer contraseña</h3>
              <p className='login-copy'>Introduzca los siguientes datos para establecer una nueva contraseña</p>
              <div className='login-input'>
                <div className='field'>
                  <label>Email de usuario</label>
                  <div className='control'>
                    <input
                      className='input'
                      required
                      type='email'
                      placeholder="Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label>Código de restablecimiento de contraseña</label>
                  <div className='control'>
                    <input
                      className='input'
                      required
                      type="text"
                      placeholder="Código"
                      value={code}
                      onChange={(e) => setCode(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label>Nueva contraseña</label>
                  <div className='control'>
                    <input
                      className='input'
                      required
                      type="password"
                      placeholder="Contraseña"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                </div>
                <button className='button is-link' type='submit'>
                  Establecer Contraseña
                </button>
              </div>
              {errorMessage && <p className='login-error'>{errorMessage}</p>}
            </div>
            <div className='login-rights'>
              <p>© {getCurrentYear()} TAVAD</p>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}
